import React, { act, useState } from 'react';
import { useFilterContext } from '../filterContext';
import { useGraphContext } from '../GraphContext';

function BreakSelector({ defaultValue = '8', onChange, setLoading }) {
  const { filter } = useFilterContext();  
  const { filters, updateGraphData } = useGraphContext();
  
  const [selected, setSelected] = useState(defaultValue);

  const sendToBackend = async (value) => {
    try {
      setLoading(true); // Show loading spinner in parent

      const getBaseURL = () => {
        const hostname = window.location.hostname;
        if (hostname === 'vuca-prod.simbaanalytics-dev.rio.cloud' || hostname === 'vuca-prod.simbaanalytics-prod.rio.cloud') {
          return 'https://2xsaaphhz4.execute-api.eu-west-1.amazonaws.com/prod';
        } else if (hostname === 'vuca-dev.simbaanalytics-dev.rio.cloud' || hostname === '8jmq9udcvt.eu-west-1.awsapprunner.com') {
          return 'https://jutwh4kwbk.execute-api.eu-west-1.amazonaws.com/dev';
        } else {
          return 'http://localhost:5000';
        }
      };
      
      const baseURL = getBaseURL();
      const accessToken = localStorage.getItem('idToken');
      
      const response = await fetch(`${baseURL}/api/breaktime`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`, // Add the access token
        },
        body: JSON.stringify({ breakInterval: value, filter }),
      });

      if (!response.ok) {
        throw new Error(`Failed to send data: ${response.status}`);
      }

      const responseData = await response.json();
      console.log('Backend response:', responseData);

      updateGraphData(prev => ({
        ...prev,
        graphs: {
          ...prev?.graphs,
          graph_url: responseData.stop_location.graph_url, // Example key
        },
        action_radius: responseData.action_radius.action_radius,
        share_of_clustered_stops: responseData.cluster_stops.share_of_clustered_stops
      }));

      // Trigger parent onChange if provided
      onChange?.(responseData);

      console.log('Break interval sent successfully:', filters);
    } catch (error) {
      console.error('Error sending break interval:', error);
    } finally {
      setLoading(false); // Hide loading spinner in parent
    }
  };

  const handleSelect = (value) => {
    console.log('Selected value:', value);
    const backendValue = value === '>=8' ? '8' : value === '>=0.5' ? '0.5' : value;
    setSelected(backendValue); // Update selected state
    sendToBackend(backendValue); // Send value to backend
  };

  // Styling
  const containerStyle = { display: 'flex', alignItems: 'center', fontFamily: 'Arial, sans-serif' };
  const labelStyle = { marginRight: '10px' };
  const groupStyle = { display: 'flex', border: '1px solid black' };
  const buttonStyle = { padding: '10px 20px', border: 'none', backgroundColor: 'white', color: 'black', cursor: 'pointer', borderRight: '1px solid black', fontWeight: 'normal' };
  const selectedStyle = { backgroundColor: 'rgb(203, 211, 220)', fontWeight: 'bold' };
  const lastButtonStyle = { borderRight: 'none' };

  return (
    <div style={containerStyle}>
      <label style={labelStyle}>Break time selection</label>
      <div style={groupStyle}>
        <button
          style={{ ...buttonStyle, ...(selected === '0.5' ? selectedStyle : {}) }}
          onClick={() => handleSelect('>=0.5')} // Pass 0.5 to the backend
        >
          >=0.5h
        </button>
        <button
          style={{ ...buttonStyle, ...lastButtonStyle, ...(selected === '8' ? selectedStyle : {}) }}
          onClick={() => handleSelect('>=8')} // Pass 8 to the backend
        >
          >=8h
        </button>
      </div>
    </div>
  );
}

export default BreakSelector;
